import Probe from "../Attributes/Facilities/Probes/Probe";
import Warehouse from "../Attributes/Facilities/Warehouse/Warehouse";
import Item from "../Attributes/Item/Item";

export function calculateInventory(warehouses: Warehouse[]) {
    let results = {
        // Item[]
        inventoryChanges: [],

        // Probe[]
        // ftr = Failed to return
        ftrProbes: [],

        // Warehouse[]
        warehouseChanges: warehouses
    }

    // Triggers game logic that takes all probes by group in each warehouse
    // If they are successfully at finding the item they are targetting
    // If so returning if they found said item, something else or nothing
    // Updating inventoryChanges to include the new items
    // If the probe was destroyed removing it from the warehouse it lived in and add it to ftrProbes
    // Once completed return final results

    // Since probes are going in batches of Probe class per warehouse able to process larger amount of probes at at time

    return results;
}